import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALTYPES_LOAD,
    ACTION_TRIALTYPES_LOAD_BY_ID,

    ACTION_TRIALTYPES_SAVE,

    ACTION_TRIALTYPES_CREATE,

    ACTION_TRIALTYPES_VALIDATE,

    ITrialTypeLoadAction,
    ITrialTypeLoadByIdAction,
    ITrialTypeLoadFailureAction,
    ITrialTypeLoadSuccessAction,

    ITrialTypeSaveAction,
    ITrialTypeSaveSuccessAction,
    ITrialTypeSaveFailureAction,

    ITrialTypeCreateAction,
    ITrialTypeCreateSuccessAction,
    ITrialTypeCreateFailureAction,

    ITrialTypeValidateAction,
    ITrialTypeValidateSuccessAction,
    ITrialTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialType";
import { trialTypesApi } from "../services/trialTypes";

export const
    getTrialTypesEpic = (action$): Observable<ITrialTypeLoadSuccessAction | ITrialTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_LOAD)
            .mergeMap((_action: ITrialTypeLoadAction) => {
                return trialTypesApi
                    .getTrialTypes()
                    .map(response =>
                        LoadSuccess(response.trialTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialTypeByIdEpic = (action$): Observable<ITrialTypeLoadSuccessAction | ITrialTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_LOAD_BY_ID)
            .mergeMap((action: ITrialTypeLoadByIdAction) => {
                return trialTypesApi
                    .getTrialTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialTypeEpic = (action$): Observable<ITrialTypeSaveSuccessAction | ITrialTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_SAVE)
            .mergeMap((action: ITrialTypeSaveAction) => {
                return trialTypesApi
                    .setTrialType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialTypeEpic = (action$): Observable<ITrialTypeCreateSuccessAction | ITrialTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_CREATE)
            .mergeMap((_action: ITrialTypeCreateAction) => {
                return trialTypesApi
                    .createTrialType()
                    .map(response =>
                        CreateSuccess(
                            response.trialType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialTypeEpic = (action$): Observable<ITrialTypeValidateSuccessAction | ITrialTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_VALIDATE)
            .mergeMap((action: ITrialTypeValidateAction) => {
                return trialTypesApi
                    .validateTrialType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }